import request from '@/plugins/axios'

export default {
  getCode(params) {
    return request.get('Yunos/User/ValidRegPhone', { params })
  },

  addUser(data) {
    return request.post('Yunos/User/AddUser', data)
  },

  forget(data) {
    return request.post('Yunos/User/ForgetPassword', data)
  },
  yanCode(data){
    return request.post(`Yunos/User/ValidRegSms`,data)
  }
}